<template>
  <el-dialog
    :title="$t('shopHouse.addShopHouse')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item
        :label="$t('shopHouse.shName')"
        prop="shName"
      >
        <el-input
          v-model="formData.shName"
          :placeholder="$t('shopHouse.inputShName')"
        />
      </el-form-item>
      <el-form-item
        :label="$t('shopHouse.shType')"
        prop="shType"
      >
        <el-select
          v-model="formData.shType"
          :placeholder="$t('shopHouse.selectShType')"
          style="width:100%"
        >
          <el-option
            v-for="item in shTypes"
            :key="item.statusCd"
            :label="item.name"
            :value="item.statusCd"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('shopHouse.shDesc')"
        prop="shDesc"
      >
        <el-input
          v-model="formData.shDesc"
          type="textarea"
          :placeholder="$t('shopHouse.inputShDesc')"
          :rows="3"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { saveShopHouse } from '@/api/goods/shopHouseApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddShopHouse',
  data() {
    return {
      dialogVisible: false,
      shTypes: [],
      formData: {
        shName: '',
        shType: '',
        shDesc: '',
        shopId: ''
      },
      rules: {
        shName: [
          { required: true, message: this.$t('shopHouse.shNameRequired'), trigger: 'blur' },
          { max: 128, message: this.$t('shopHouse.shNameTooLong'), trigger: 'blur' }
        ],
        shType: [
          { required: true, message: this.$t('shopHouse.shTypeRequired'), trigger: 'change' }
        ],
        shDesc: [
          { required: true, message: this.$t('shopHouse.shDescRequired'), trigger: 'blur' },
          { max: 512, message: this.$t('shopHouse.shDescTooLong'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.getDictData()
    },
    async getDictData() {
      try {
        const {data} = await getDict('s_shop_house', 'sh_type')
        this.shTypes = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        
        try {
          let shopId = getShopId()
          this.formData.shopId = shopId
          await saveShopHouse(this.formData)
          this.$message.success(this.$t('common.submitSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        } catch (error) {
          console.error('添加仓库失败:', error)
        }
      })
    }
  }
}
</script>